var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCancel = function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 13 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.95 1.05a.875.875 0 0 1 0 1.238L7.237 6l3.713 3.712a.875.875 0 0 1-1.238 1.238L6 7.237 2.288 10.95A.875.875 0 0 1 1.05 9.712L4.762 6 1.05 2.288A.875.875 0 0 1 2.288 1.05L6 4.763 9.712 1.05a.875.875 0 0 1 1.238 0z"
  })));
};

export default SvgCancel;